import React, { useEffect, useState } from "react";
import "./SelectWalkAroundModal.styles.css";
import "./../CognitiveServices/inputPicker.css";
import { Modal } from "react-bootstrap";
import { ReactComponent as ArrowDown } from "../../../assets/icons/HeaderIcons/arrow-gray-down.svg";

import InputPicker from "rsuite/InputPicker";

type DataItemType = {
  value: string;
  label: string;
  children?: Array<DataItemType>; // property value is the value of childrenKey
  groupBy?: string;
};

type ItemDataType = {
  label?: string | React.ReactNode;
  value?: string | number;
  groupBy?: string;
  parent?: ItemDataType;
  children?: ItemDataType[];
  loading?: boolean;
};

const SelectWalkAroundModal = (props: any) => {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [models, setModels] = useState<DataItemType[]>([{ value: "", label: "" }]);
  // const [isSelected, setIsSelected] = useState<boolean>(false);

  useEffect(() => {
    modelSelector();
  }, [props.walkaroundSelectorShowing]);

  React.useEffect(() => {
    if (props.walkaroundModels.length > 0) {
      props.setCurrentWalkAroundObject({
        modelSet: props.walkaroundModels[selectedIndex].blobPath,
        role: "Captain",
        assetVersionId: props.walkaroundModels[selectedIndex].assetVersionId,
      });
    }
  }, [selectedIndex, props.walkaroundSelectorShowing]);

  const handleCancel = () => {
    props.setWalkaroundSelectorShowing(false);
  };

  const handleSelect = () => {
    // if(isSelected){
    //     if(props.walkaroundModels.length > 0){
    //         props.setCurrentWalkAroundObject({modelSet: props.walkaroundModels[selectedIndex].blobPath, role: "Captain", assetVersionId:props.walkaroundModels[selectedIndex].assetVersionId})
    //     }
    //
    // }
    props.addNewPageAndDisplay(props.currentlyDisplayedPageIndex + 1, "Walkaround", "Walk Around");
    handleCancel();
  };

  const modelSelector = () => {
    const models = props.walkaroundModels.map((model: any, index: number) => {
      return {
        value: index,
        label: model.name,
      };
    });

    setModels(models);
  };

  function handleOnChange(e: number) {
    setSelectedIndex(e);
    // setIsSelected(true);
  }

  const ShowModelSelector = () => {
    const myProps = {
      caretComponent: ArrowDown,
    };

    return (
      <InputPicker
        {...myProps}
        data={models}
        appearance="default"
        placeholder="Select a walk around"
        labelKey={"label"}
        valueKey={"value"}
        onChange={(e) => {
          handleOnChange(e);
        }}
        size={"sm"}
        cleanable={false}
        className={"model-dropdown"}
        menuMaxHeight={150}
      />
    );
  };

  return (
    <>
      {props.walkaroundSelectorShowing && (
        <Modal
          show={props.walkaroundSelectorShowing}
          onHide={handleCancel}
          dialogClassName={"wa-modal"}
          backdrop={"static"}
          keyboard={false}
          bsPrefix={"wa"}
        >
          <Modal.Header closeButton>
            <Modal.Title className={"wa-title"}>
              <p>Walk Around Model</p>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body bsPrefix={"wa-body"}>
            <label className={"text-area-label"}>Select a model to continue:</label>
            <ShowModelSelector />
          </Modal.Body>

          <Modal.Footer>
            <div className="wa-modal-buttons">
              <button onClick={handleCancel}>Cancel</button>
              <button onClick={handleSelect}>Confirm</button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default SelectWalkAroundModal;
